import {
  AdjustmentsIcon,
  ArrowSmRightIcon,
  CheckIcon,
  ChevronDoubleDownIcon,
  ChevronDoubleRightIcon,
  InformationCircleIcon,
  LockClosedIcon,
  LockOpenIcon,
  PencilIcon,
  PlusIcon,
  StarIcon,
  TrashIcon,
  TrendingUpIcon,
} from "@heroicons/react/outline";
import { ExclamationIcon, XIcon } from "@heroicons/react/solid";
import {
  ArrowLeft,
  ArrowRight,
  BarChartSquare01,
  Calendar,
  ChevronDown,
  ChevronUp,
  Clipboard,
  ClockRewind,
  Compass03,
  DotsHorizontal,
  Edit05,
  Expand01,
  FileSearch01,
  Home02,
  LayoutGrid01,
  LineChartUp01,
  LinkExternal01,
  MessageSquare02,
  PlusCircle,
  RefreshCcw02,
  Star04,
  Target05,
  ThumbsDown,
  ThumbsUp,
  Trophy01,
  Upload04,
  User01,
  Users01,
} from "@untitled-ui/icons-react";
import { SVGProps } from "react";
import { IconType } from "react-icons";
import { BiCommentAdd } from "react-icons/bi";
import { FaArrowDown, FaArrowUp, FaEquals } from "react-icons/fa6";
import { GoArrowDownRight, GoArrowUpRight } from "react-icons/go";
import {
  HiDotsHorizontal,
  HiOutlineEye,
  HiOutlineEyeOff,
  HiOutlineSwitchHorizontal,
} from "react-icons/hi";
import { IoMdExit, IoMdHappy } from "react-icons/io";
import { LiaUserEditSolid } from "react-icons/lia";
import {
  MdCheckBoxOutlineBlank,
  MdContentCopy,
  MdFilterAlt,
  MdOutlineChat,
  MdOutlineCheckBox,
  MdOutlineDragIndicator,
  MdRadioButtonChecked,
  MdRadioButtonUnchecked,
} from "react-icons/md";
import { PiTextAlignLeftBold } from "react-icons/pi";
import { RxDotFilled } from "react-icons/rx";
import { TbBuilding, TbLayoutSidebarFilled } from "react-icons/tb";

export const TopicflowIconMap = {
  actionItem: MdCheckBoxOutlineBlank,
  adjustments: AdjustmentsIcon,
  ai: Star04,
  arrowLeft: ArrowLeft,
  arrowRight: ArrowRight,
  assessment: BarChartSquare01,
  chat: MdOutlineChat,
  chatAdd: BiCommentAdd,
  check: CheckIcon,
  chevronDown: ChevronDown,
  chevronDownDouble: ChevronDoubleDownIcon,
  chevronRightDouble: ChevronDoubleRightIcon,
  chevronUp: ChevronUp,
  close: XIcon,
  copy: MdContentCopy,
  dot: RxDotFilled,
  downArrow: FaArrowDown,
  downRightArrow: GoArrowDownRight,
  drag: MdOutlineDragIndicator,
  edit: PencilIcon,
  equals: FaEquals,
  exit: IoMdExit,
  expandArrows: Expand01,
  explorer: Compass03,
  externalLink: LinkExternal01,
  eye: HiOutlineEye,
  eyeOff: HiOutlineEyeOff,
  feedback: Upload04,
  fileSearch: FileSearch01,
  filter: MdFilterAlt,
  goal: Target05,
  home: Home02,
  horizontalDots: DotsHorizontal,
  info: InformationCircleIcon,
  kpi: TrendingUpIcon,
  lock: LockOpenIcon,
  lockClosed: LockClosedIcon,
  meeting: Calendar,
  MessageSquare02: MessageSquare02,
  multichoice: MdOutlineCheckBox,
  nps: IoMdHappy,
  organization: TbBuilding,
  pencilSquare: Edit05,
  plus: PlusIcon,
  plusCircle: PlusCircle,
  previous: ClockRewind,
  program: LayoutGrid01,
  radioButtonChecked: MdRadioButtonChecked,
  radioButtonUnchecked: MdRadioButtonUnchecked,
  range: HiDotsHorizontal,
  recognition: Trophy01,
  refresh: RefreshCcw02,
  reporting: LineChartUp01,
  rightArrow: ArrowSmRightIcon,
  sidebar: TbLayoutSidebarFilled,
  star: StarIcon,
  survey: Clipboard,
  switch: HiOutlineSwitchHorizontal,
  text: PiTextAlignLeftBold,
  threads: MessageSquare02,
  thumbsDown: ThumbsDown,
  thumbsUp: ThumbsUp,
  trash: TrashIcon,
  upArrow: FaArrowUp,
  upRightArrow: GoArrowUpRight,
  user: User01,
  userEdit: LiaUserEditSolid,
  users: Users01,
  warning: ExclamationIcon,
};

export type TopicflowIconType = keyof typeof TopicflowIconMap;

export const getTopicflowIcon = (
  type: TopicflowIconType,
): ((props: SVGProps<SVGSVGElement>) => React.JSX.Element) | IconType => {
  if (type in TopicflowIconMap) {
    return TopicflowIconMap[type];
  }
  throw new Error(`Unknown icon type: ${type}`);
};
